import React from "react";
import NextLink from "components/parts/NextLink";
import { BreadCrumbBox, LinkBox } from "./BreadCrumbs.styled";
import type { BreadcrumbProps, CtaProps } from "types/prices";
import { Body } from "app/_components/components/Text/Body";

const BreadCrumbs = (props: BreadcrumbProps) => {
  const { cta } = props?.breadcrumbs || {};
  const renderText = ({ name }: { name: string }) => {
    return (
      <Body size={"sm"} className="firstBreadcrumb underline">
        {name}
      </Body>
    );
  };

  return (
    <BreadCrumbBox>
      <LinkBox>
        {cta &&
          cta.length > 0 &&
          cta.map((data: CtaProps, index: number) => {
            if (data?.link) {
              return (
                <NextLink
                  href={data?.link}
                  id={`breadcrumb-${index}`}
                  key={index}
                >
                  {renderText({ name: data?.name })}
                </NextLink>
              );
            } else {
              return (
                <React.Fragment key={index}>
                  {renderText({ name: data?.name })}
                </React.Fragment>
              );
            }
          })}
      </LinkBox>
    </BreadCrumbBox>
  );
};

export default BreadCrumbs;
